module.exports = __webpack_public_path__ + "static/img/bg16.dd06b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg16.jpg
// module id = j/WL
// module chunks = 1